import { render, staticRenderFns } from "./AddResumeModal.vue?vue&type=template&id=40778ee0&scoped=true"
import script from "./AddResumeModal.vue?vue&type=script&lang=ts"
export * from "./AddResumeModal.vue?vue&type=script&lang=ts"
import style0 from "./AddResumeModal.vue?vue&type=style&index=0&id=40778ee0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40778ee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40778ee0')) {
      api.createRecord('40778ee0', component.options)
    } else {
      api.reload('40778ee0', component.options)
    }
    module.hot.accept("./AddResumeModal.vue?vue&type=template&id=40778ee0&scoped=true", function () {
      api.rerender('40778ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/AddResumeModal.vue"
export default component.exports